module.exports = __webpack_public_path__ + "static/media/hotel.4b45c516.svg";